var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddToSharedAlbumFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0C6.44772 0 6 0.447715 6 1C6 1.55228 6.44772 2 7 2H15C16.1046 2 17 2.89543 17 4V12.5C17 13.0523 17.4477 13.5 18 13.5C18.5523 13.5 19 13.0523 19 12.5V4C19 1.79086 17.2091 0 15 0H7ZM3.44444 5C3.19898 5 3 5.19898 3 5.44444V15.5556C3 15.801 3.19898 16 3.44444 16H3.5896L9.96059 9.71209L9.96069 9.71198C10.4242 9.25462 11.0501 9 11.7 9C12.3498 9 12.9757 9.25462 13.4392 9.71198L13.4394 9.71209L14 10.2654V5.44444C14 5.19898 13.801 5 13.5556 5H3.44444ZM3.44444 18H3.99997H13H13.5556C14.9056 18 16 16.9056 16 15.5556V5.44444C16 4.09441 14.9056 3 13.5556 3H3.44444C2.09441 3 1 4.09441 1 5.44444V15.5556C1 16.9056 2.09441 18 3.44444 18ZM4 8C4 6.89543 4.89543 6 6 6C7.10457 6 8 6.89543 8 8C8 9.10457 7.10457 10 6 10C4.89543 10 4 9.10457 4 8ZM20 16C20.5523 16 21 16.4477 21 17V19H23C23.5523 19 24 19.4477 24 20C24 20.5523 23.5523 21 23 21H21V23C21 23.5523 20.5523 24 20 24C19.4477 24 19 23.5523 19 23V21H17C16.4477 21 16 20.5523 16 20C16 19.4477 16.4477 19 17 19H19V17C19 16.4477 19.4477 16 20 16Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToSharedAlbumFilled);
export default __webpack_public_path__ + "static/media/add-to-shared-album-filled.9ef86f641335f36bb5b7cbf3c9718b2f.svg";
export { ForwardRef as ReactComponent };